import { Navigate, Outlet } from "react-router";
import { AuthContext } from "./context/auth.context.ts";
import { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Suspense } from "react";

export default function Protected() {
    const userContext = useContext(AuthContext);
    const [isLog, setLog] = useState(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (!isLog) {
            setLog(userContext.loadUser())
            setLoad(true);
        }
    }, [isLog]);

    return <Suspense fallback="Loading...">
        {load ? <>
            {isLog
                ? <Outlet /> : <Navigate to="/login" />}
        </> : "Loading..."}

    </Suspense>

};